/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

const nriFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [{
    "@type": "Question",
    name: "Can I invest in NRE and NRO accounts as an NRI?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "You can invest in NRE and NRO accounts as an NRI"
    }
  },
  {
    "@type": "Question",
    name: "Can I enjoy tax exemptions and deductions as an NRI?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      While filing your income tax return in India, you can claim the deductions available under the Income Tax Act
      `
    }
  },
  {
    "@type": "Question",
    name: "For long-term capital gain, NRIs can claim tax exemption under which sections of the Income Tax Act?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Tax exemption can be claimed under Section 54, Section 54EC, and Section 54F of the Income Tax Act.
      `
    }
  },
  {
    "@type": "Question",
    name: "What is the maximum deduction I can avail as an NRI for investing in ELSS of mutual funds",
    acceptedAnswer: {
      "@type": "Answer",
      text: "You can avail a maximum deduction of Rs 1.5 lakh in a year for investing in ELSS as an NRI"
    }
  }
  ]
}
;

export default nriFaqSchema;
